import { render, staticRenderFns } from "./ycjl.vue?vue&type=template&id=371d871c&"
import script from "./ycjl.vue?vue&type=script&lang=js&"
export * from "./ycjl.vue?vue&type=script&lang=js&"
import style0 from "./ycjl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports